/* AV Simplistics — Theme JS */

// Nav scroll state
const nav = document.getElementById('av-nav');
if (nav) {
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 50);
  });
}

// Scroll reveal
const revealEls = document.querySelectorAll('.reveal');
if (revealEls.length) {
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.1 });
  revealEls.forEach(el => io.observe(el));
}

// Cart drawer
const cartDrawer = document.getElementById('av-cart-drawer');
const cartOpen = document.querySelectorAll('[data-cart-open]');
const cartClose = document.getElementById('av-cart-close');

if (cartDrawer) {
  cartOpen.forEach(btn => btn.addEventListener('click', (e) => {
    e.preventDefault();
    cartDrawer.classList.add('open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }));
  if (cartClose) {
    cartClose.addEventListener('click', () => {
      cartDrawer.classList.remove('open');
      document.body.style.overflow = '';
    });
  }
}

// Fetch and render cart
async function fetchCart() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    renderCart(cart);
  } catch(err) { console.error('Cart fetch failed', err); }
}

function renderCart(cart) {
  const itemsEl = document.getElementById('av-cart-items');
  const subtotalEl = document.getElementById('av-cart-subtotal');
  if (!itemsEl) return;

  if (cart.items.length === 0) {
    itemsEl.innerHTML = '<div class="av-cart-drawer__empty">Your cart is empty.</div>';
  } else {
    itemsEl.innerHTML = cart.items.map(item => `
      <div class="av-cart-item">
        <img class="av-cart-item__img" src="${item.image}" alt="${item.title}" />
        <div class="av-cart-item__info">
          <p class="av-cart-item__name">${item.product_title}</p>
          <p class="av-cart-item__variant">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</p>
          <p class="av-cart-item__price">$${(item.price / 100).toFixed(2)}</p>
          <div class="av-cart-item__qty">
            <button class="av-cart-item__qty-btn" data-qty-key="${item.key}" data-qty-change="-1">−</button>
            <span class="av-cart-item__qty-num">${item.quantity}</span>
            <button class="av-cart-item__qty-btn" data-qty-key="${item.key}" data-qty-change="1">+</button>
          </div>
          <button
            class="av-cart-item__remove"
            data-remove-key="${item.key}"
            aria-label="Remove ${item.product_title}"
          >Remove</button>
        </div>
      </div>
    `).join('');
  }

  if (subtotalEl) {
    subtotalEl.textContent = '$' + (cart.total_price / 100).toFixed(2);
  }

  updateCartCount(cart.item_count);
}

function updateCartCount(count) {
  document.querySelectorAll('.av-cart-count').forEach(el => {
    el.textContent = count;
    el.style.display = count > 0 ? 'inline-flex' : 'none';
  });
}

// Remove item from cart
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-remove-key]');
  if (!btn) return;
  const key = btn.dataset.removeKey;
  btn.textContent = 'Removing...';
  btn.disabled = true;
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    if (res.ok) await fetchCart();
  } catch(err) { console.error('Remove failed', err); }
});

// Quantity change
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-qty-key]');
  if (!btn) return;
  const key = btn.dataset.qtyKey;
  const change = parseInt(btn.dataset.qtyChange);
  const qtyEl = btn.parentElement.querySelector('.av-cart-item__qty-num');
  const currentQty = parseInt(qtyEl.textContent);
  const newQty = Math.max(0, currentQty + change);
  btn.disabled = true;
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    });
    if (res.ok) await fetchCart();
  } catch(err) { console.error('Qty update failed', err); }
});

// Add to cart
document.addEventListener('submit', async (e) => {
  if (!e.target.matches('[data-add-to-cart-form]')) return;
  e.preventDefault();
  const form = e.target;
  const btn = form.querySelector('[data-add-to-cart-btn]');
  const originalText = btn ? btn.textContent : '';
  if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }

  try {
    const formData = new FormData(form);
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    });
    if (res.ok) {
      if (btn) { btn.textContent = 'Added'; }
      await fetchCart();
      if (cartDrawer) {
        setTimeout(() => {
          cartDrawer.classList.add('open');
          document.body.style.overflow = 'hidden';
        }, 300);
      }
    }
  } catch(err) { console.error('Add to cart failed', err); }

  setTimeout(() => {
    if (btn) { btn.textContent = originalText; btn.disabled = false; }
  }, 1500);
});

// Update cart count on page load
fetch('/cart.js').then(r => r.json()).then(cart => updateCartCount(cart.item_count)).catch(() => {});
